import { default as VeneerCard } from '@veneer/core/dist/esm/scripts/card'
import classes from './Card.module.scss'
import React from 'react'

const Card = ({ children, border, className }) => {
  return (
    <div className={classes.container}>
      <VeneerCard border={border} className={`${classes.card} ${className}`}>
        {children}
      </VeneerCard>
    </div>
  )
}

export default Card
